function createBangleJSUiCode(x, y, z, renderBox, name, slStartX, slStartY, length, sliderPosition, sliderSize, vertical, sliderHitBoxOffset) {
  return {
    active: true,
    name,
    x,
    y,
    z,
    renderBoxTlX: renderBox.tl.x,
    renderBoxTlY: renderBox.tl.y,
    renderBoxBrX: renderBox.br.x,
    renderBoxBrY: renderBox.br.y,
    slStartX,
    slStartY,
    length,
    sliderSize,
    sliderPosition,
    sliderHitBoxOffset,
    vertical,
    clicked: false,
    onDragStart: (position) => null,
    onDragUpdate: (position) => null,
    onDragEnd: (position) => null,

    render: function () {
      const start = {
        x: this.x - this.sliderSize - 1, y: this.y - this.sliderSize - 1
      };
      const end = {
        x: this.x + (this.vertical ? 0 : this.length) + this.sliderSize + 1,
        y: this.y + (this.vertical ? this.length : 0) + this.sliderSize + 1
      };
      g.clearRect(start.x, start.y, end.x, end.y);
      g.drawLine(this.slStartX, this.slStartY, this.vertical ? this.slStartX : this.slStartX + this.length, this.vertical ? this.slStartY + this.length : this.slStartY);
      g.fillCircle(this.vertical ? this.slStartX : this.slStartX + this.length * this.sliderPosition, this.vertical ? this.slStartY + this.length * this.sliderPosition : this.slStartY, this.sliderSize);
    },
    getSliderPosition: function () {
      const sliderX = this.vertical ? this.slStartX : this.slStartX + this.length * this.sliderPosition;
      const sliderY = this.vertical ? this.slStartY + this.length * this.sliderPosition : this.slStartY;
      return {x: sliderX, y: sliderY};
    },
    wasTouched: function (e) {
      if (!this.active) return;
      const sliderPosition = this.getSliderPosition();
      return Math.sqrt(Math.pow(sliderPosition.x - e.x, 2) + Math.pow(sliderPosition.y - e.y, 2)) < this.sliderSize + this.sliderHitBoxOffset;
    },
    onScreenTouch: function (e) {
      if (!this.active) return;

      if (this.vibrate) {
        Bangle.buzz(100, 0.2);
      }
    },
    onDrag: function (e) {
      if (!this.active) return;

      if (!this.clicked && this.wasTouched(e)) {
        this.clicked = true;
        this.onDragStart(this.vertical ? 1 - this.sliderPosition : this.sliderPosition);
      }
      if (this.clicked) {
        const sliderPosition = this.getSliderPosition();
        if (this.vertical) {
          if (sliderPosition.y + e.dy >= this.slStartY && sliderPosition.y + e.dy <= this.slStartY + this.length) {
            this.sliderPosition = (sliderPosition.y + e.dy - this.slStartY) / this.length;
          }

          if (sliderPosition.y + e.dy < this.slStartY) {
            this.sliderPosition = 0;
          }
          if (sliderPosition.y + e.dy > this.slStartY + this.length) {
            this.sliderPosition = 1;
          }
        } else {
          if (sliderPosition.x + e.dx >= this.slStartX && sliderPosition.x + e.dx <= this.slStartX + this.length) {
            this.sliderPosition = (sliderPosition.x + e.dx - this.slStartX) / this.length;
          }
          if (sliderPosition.x + e.dx < this.slStartX) {
            this.sliderPosition = 0;
          }
          if (sliderPosition.x + e.dx > this.slStartX + this.length) {
            this.sliderPosition = 1;
          }
        }
        this.onDragUpdate(this.vertical ? 1 - this.sliderPosition : this.sliderPosition);
      }
      if (e.b === 0 && this.clicked) {
        this.onDragEnd(this.vertical ? 1 - this.sliderPosition : this.sliderPosition);
        this.clicked = false;
      }
      this.render();
    }
  }
}

module.exports = {
  createBangleJSUiCode
}
